var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlik = function SvgBlik(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 20,
    viewBox: "0 0 39 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6077 3.26947C12.6077 1.7077 11.3565 0.397827 9.80499 0.397827C8.2535 0.397827 7.0023 1.7077 7.0023 3.26947C7.0023 4.83125 8.2535 6.09074 9.80499 6.09074C11.3565 6.09074 12.6077 4.83125 12.6077 3.26947ZM14.8098 19.2902H17.9628V1.30463H14.8098V19.2902ZM23.9185 19.2903H20.7655V7.55178H23.9185V19.2903ZM3.79923 8.10592C4.65005 7.6525 5.60096 7.4006 6.65197 7.4006C9.95514 7.4006 12.6077 10.1211 12.6077 13.3958C12.6077 16.7209 9.95514 19.4414 6.65197 19.4414C3.3488 19.4414 0.64621 16.7209 0.64621 13.3958V1.30465H3.79923V8.10592ZM3.74915 13.3958C3.74915 15.008 5.0504 16.3179 6.65194 16.3179C8.20343 16.3179 9.50467 15.008 9.50467 13.3958C9.50467 11.8341 8.20343 10.5242 6.65194 10.5242C5.0504 10.5242 3.74915 11.8341 3.74915 13.3958ZM38.3323 19.2902H34.2784L29.8242 12.9927L34.1783 7.55173H37.8318L33.4276 12.9424L38.3323 19.2902ZM29.8242 12.9927V19.2902H26.6711V1.30463H29.8242V12.9927Z",
    fill: "#D5D4D3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlik, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blik.f3872fac.svg";
export { ForwardRef as ReactComponent };